import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "table-responsive" }
const _hoisted_2 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 table-hover" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-50px" }, "ID"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-5px" }, "Tên"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-50px" }, "Mã"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-50px" }, "Đơn giá"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-50px" }, "Thu hồi"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-50px" }, "C/ty duyệt"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-50px" }, "Số lượng"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-50px" }, "Ngày tạo"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-50px" }, "Ngày sửa"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" })
  ])
], -1)
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "form-check form-check-custom form-check-solid form-check-sm justify-content-center pr-5" }
const _hoisted_6 = ["checked"]
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "form-check form-check-custom form-check-solid form-check-sm justify-content-centerpr-5" }
const _hoisted_9 = ["checked"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (s) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: s.id,
            class: "hover-pointer"
          }, [
            _createElementVNode("td", null, _toDisplayString(s.id), 1),
            _createElementVNode("td", null, _toDisplayString(s.ten_vat_tu), 1),
            _createElementVNode("td", null, _toDisplayString(s.ma_vat_tu), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.formatCurrencyAndQuantity(s.don_gia)), 1),
            _createElementVNode("td", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("input", {
                  class: "form-check-input form-check-sm",
                  type: "checkbox",
                  disabled: "disabled",
                  value: "",
                  readonly: "",
                  checked: s.thu_hoi
                }, null, 8, _hoisted_6)
              ])
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("input", {
                  class: "form-check-input form-check-sm",
                  type: "checkbox",
                  disabled: "disabled",
                  value: "",
                  readonly: "",
                  checked: s.cong_ty_duyet
                }, null, 8, _hoisted_9)
              ])
            ]),
            _createElementVNode("td", null, _toDisplayString(s.quantity), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.moment(s.created_at).format("DD/MM/YYYY")), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.moment(s.updated_at).format("DD/MM/YYYY")), 1),
            (_ctx.isCreated)
              ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
                  _createElementVNode("button", {
                    onClick: _withModifiers(($event: any) => (_ctx.onClickDeleteHandler(s.id)), ["prevent"]),
                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                  }, [
                    _createElementVNode("span", _hoisted_12, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen027.svg" })
                    ])
                  ], 8, _hoisted_11)
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ]))
}